// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"443":"301c5d1d","445":"3a0761d3","536":"5baee07c","666":"753971e9","680":"aadd57d6","776":"6bf77269","874":"594860cc","926":"d1bbcd8a"}[chunkId] + ".chunk.css";
};